import React, { useState, useEffect } from "react";

import RTMService from "../../services/rtm";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import colors from "../../styles/colors";
import { colorsV2 } from "../../styles/colors";
import Dialog from "material-ui/Dialog";
import DatePicker from "material-ui/DatePicker";
import CalIcon from "material-ui/svg-icons/action/date-range";
import CancelIcon from "material-ui/svg-icons/navigation/cancel";
import { Checkbox } from "@material-ui/core";
import events from "../../services/events";

export default (props) => {

  const [show, setShow] = useState(false);
  const [claimDate, setClaimDate] = useState(new Date());
  const [sevenFive, setSevenFive] = useState(props.sevenFiveEnabled);
  const [sevenSeven, setSevenSeven] = useState(props.sevenSevenEnabled);
  const [eightZero, setEightZero] = useState(props.eightZeroEnabled);
  const [eightOne, setEightOne] = useState(props.eightOneEnabled);

  useEffect(() => {
    setSevenFive(props.sevenFiveEnabled);
    setSevenSeven(props.sevenSevenEnabled);
    setEightZero(props.eightZeroEnabled);
    setEightOne(props.eightOneEnabled);
  }, [props]);

  useEffect(() => {
    setShow(props.showPopup);
  }, [props.showPopup]);

  return (
    <Dialog
      title={"Track Claim Submission"}
      modal={true}
      open={show}
      onRequestClose={() => {
        setShow(false);
        props.setShowPopup(false);
      }}
      style={{ width: 1050, marginLeft: "20%" }}
    >
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          padding: 10,
          justifyContent: "left",
          justifyItems: "left",
        }}
      >
        <IconButton
          onClick={() => {
            setShow(false);
            props.setShowPopup(false);
          }}
          style={{ position: "absolute", top: 10, right: 10 }}
        >
          <CancelIcon />
        </IconButton>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 7,
            width: 325,
            padding: 5,
            overflow: "hidden",
          }}
        >
          <span style={{ fontSize: 12, color: colors.accent, padding: 2 }}>
            Claim(s) Submitted On
          </span>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <DatePicker
              defaultDate={claimDate}
              hideCalendarDate={true}
              maxDate={new Date()}
              onChange={(event, date) => {
                setClaimDate(date);
              }}
              style={{
                fontSize: 14,
                width: 325,
              }}
              containerStyle={{ width: 100 }}
            />
            <CalIcon />
          </div>
        </div>
        <p style={{ color: colors.primary }}>
          Please check off the items below which have been recently submitted.
        </p>
        <p>Note: Items appearing in grey are not eligible for submission.</p>
        <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
          <div style={{ flexDirection: "column" }}>
            <div
              style={{
                flexDirection: "row",
                color: props.sevenFiveEnabled ? colors.primary : colors.grey,
              }}
            >
              <Checkbox
                color="grey"
                checked={sevenFive}
                disabled={!props.sevenFiveEnabled}
                onChange={() => {
                  setSevenFive(!sevenFive);
                }}
              />
              98975 - Initial Setup & Patient Education
            </div>
            <div
              style={{
                flexDirection: "row",
                color: props.sevenSevenEnabled ? colors.primary : colors.grey,
              }}
            >
              <Checkbox
                color="grey"
                checked={sevenSeven}
                disabled={!props.sevenSevenEnabled}
                onChange={() => {
                  setSevenSeven(!sevenSeven);
                }}
              />
              98977/989X6 - Supply And Use Of Device For Monitoring
            </div>
            <div
              style={{
                flexDirection: "row",
                color: props.eightZeroEnabled ? colors.primary : colors.grey,
              }}
            >
              <Checkbox
                color="grey"
                checked={eightZero}
                disabled={!props.eightZeroEnabled}
                onChange={() => {
                  setEightZero(!eightZero);
                }}
              />
              98980 - Monitoring/Treatment Management Services, First 20 Minutes
            </div>
            <div
              style={{
                flexDirection: "row",
                color: props.eightOneEnabled ? colors.primary : colors.grey,
              }}
            >
              <Checkbox
                color="grey"
                disabled={!props.eightOneEnabled}
                checked={eightOne}
                onChange={() => {
                  setEightOne(!eightOne);
                }}
              />
              98981 - Monitoring/Treatment Management Services, Each Additional
              20 Minutes
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row", margin: 20 }}>
          <Button
            variant="outlined"
            style={{
              color: colorsV2.primary,
              backgroundColor: "white",
              cursor: "pointer",
              marginRight: 20,
              width: "100%",
            }}
            onClick={() => {
              setShow(false);
              props.setShowPopup(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            style={{
              color: colorsV2.white,
              backgroundColor: colorsV2.lightningYellow,
              cursor: "pointer",
              marginRight: 20,
              width: "100%",
            }}
            onClick={() => {
              props.markBillingComplete(
                props.customAppId,
                claimDate,
                sevenFive,
                sevenSeven,
                eightOne,
                eightZero
              );

              events().trackUserEvent(
                "RTM Report-Submitted",
                props.appId,
                props.customAppId,
                null,
                null,
                props.providerUserId,
                props.patientUserId,
                "portal",
                props.appInfo.appName,
                null,
                JSON.stringify({
                  customAppId: props.customAppId,
                  claimDate,
                  sevenFive,
                  sevenSeven,
                  eightOne,
                  eightZero,
                })
              );
              setShow(false);
              props.setShowPopup(false);
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/components/rtm/RTMBillingPopup.js